// Help text explaining query syntax conventions
export const BLOB_CONNECTION_STRING_SYNTAX_HELP_TEXT = {
  string:
    "DefaultEndpointsProtocol=https;AccountName={accountName};AccountKey={accountKey};EndpointSuffix=core.windows.net",
  helpText:
    "Replace {accountName} and {accountKey} with your actual Blob Connection details",
};

export const MARIADB_CONNECTION_STRING_SYNTAX_HELP_TEXT = {
  string:
    "mysql+pymysql://{username}:{password}@{serverIp}:{serverPort}/{database_name}?charset=utf8mb4",
  helpText:
    "Replace {username}, {password}, {serverIp}, {serverPort}, and {database_name} with your MariaDB connection details",
};

export const AZURE_SQL_CONNECTION_STRING_SYNTAX_HELP_TEXT = {
  string:
    "mssql+pyodbc:///?odbc_connect=Driver={ODBC Driver 18 for SQL Server};Server=tcp:{databasePath},1433;Database={databaseName};Uid={uid};Pwd={password};Encrypt=yes;TrustServerCertificate=no;Connection Timeout=30",
  helpText:
    "Replace {databasePath}, {databaseName}, {uid}, and {password} with your Azure SQL connection details",
};

export const ORACLE_SQL_CONNECTION_STRING_SYNTAX_HELP_TEXT = {
  string: "{username}/{password}@{hostIp}/{service_name}",
  helpText:
    "Replace {username}, {password}, {hostIp}, and {service_name} with your Oracle database credentials and connection details",
};

export const SNOFLAKE_SQL_CONNECTION_STRING_SYNTAX_HELP_TEXT = {
  string:
    "account={accountName};user={userName};password={password};warehouse={warehouseName};database={databaseName};schema={schema}",
  helpText:
    "Replace {accountName}, {userName}, {password}, {warehouseName}, {databaseName}, and {schema} with your Snowflake account details",
};

export const AZURE_SQL_SERVICE_PRINCIPAL_CONNECTION_STRING_SYNTAX_HELP_TEXT = {
  string:
    "Driver={ODBC Driver 17 for SQL Server};Server=tcp:{databasePath},1433;Database={databaseName};Uid={uid};Pwd={password};Encrypt=yes;TrustServerCertificate=no;Connection Timeout=30",
  helpText:
    "Replace {databasePath}, {databaseName}, {uid}, and {password} with your Azure SQL Service Principal connection details",
};

export const POSTGRES_SQL_CONNECTION_STRING_SYNTAX_HELP_TEXT = {
  string:
    "postgresql+psycopg2://{username}:{password}@{host}:{port}/{database_name}",
  helpText:
    "Replace {username}, {password}, {host}, {port}, and {database_name} with your PostgreSQL connection details",
};
